<template>
  <div>
    <p class="text-xs-center">#{{event.event_no}} {{event.gender}} {{event.agegroup}} {{event.distance}} {{event.stroke}}</p>
    <v-data-table :headers="headers" :items="results"
      class="elevation-1" :custom-sort="customSort" disable-initial-sort
      :rows-per-page-items='[{"text":"$vuetify.dataIterator.rowsPerPageAll","value":-1},5,10,25]'>
      <template v-slot:items="props">
        <td>{{ props.item.team }}</td>
        <td>{{ props.item.letter }} ({{ props.item.athletes}})</td>
        <td>{{ props.item.place }}</td>
        <td>{{ props.item.points }}</td>
        <td>{{ props.item.seed }}</td>
        <td>{{ props.item.finish }}</td>
    </template>
  </v-data-table>
  </div>
</template>

<script>
  export default {
    methods: {
      customSort(items, index, isDesc) {
        if(index===null) {
          return items;
        }
        items.sort((a, b) => {
          if (!isDesc) {
            return a[index] < b[index] ? -1 : 1;
          } else {
            return b[index] < a[index] ? -1 : 1;
          }
        });
        if(index==='place' || index===null) {
            return [].concat(...
              items.filter((el) => el.place!==0),
              items.filter((el) => el.place===0));
        }
        return items;
      },
      pad(n) {
        return `00${n}`.slice(-2);
      },
      finishTime({time,stat}) {
        if(stat.trim() === '') {
          return this.getTime(time);
        } else if(stat === 'Q') {
          return 'DQ';
        }
        return 'NS';
      },
      getTime(t) {
        if(t > 60) {
          return `${Math.floor(t/60)}:${this.pad(Math.floor(t%60))}.${this.pad(Math.round((t%1)*100))}`;
        }
        return `${this.pad(Math.floor(t%60))}.${this.pad(Math.round((t%1)*100))}`;
      }
    },
    data: () => ({
      headers: [
        {text: "Team", value: "team", align: 'left', sortable: true},
        {text: "Name", value: "name", align: 'left', sortable: true},
        {text: "Place", value: "place", align: 'left', sortable: true},
        {text: "Points", value: "points", align: 'left', sortable: true},
        {text: "Seed", value: "seed", align: 'left', sortable: true},
        {text: "Finish", value: "finish", align: 'left', sortable: true},
      ],
      date: "1234",
      eventno: "",
      teams: [],
      event: {},
      results: []
    }),
    created() {
      this.eventno = this.$route.query.eventno;
      this.teams = this.$route.query.team;
      this.date = this.$route.query.date;
      this.$http.get(`${process.env.VUE_APP_API_URL}/relay?date=${this.date}&eventno=${this.eventno}&team=${this.teams.join("&team=")}`)
      .then(function(data) {
        this.event = data.body.event[0];
        this.results = data.body.results.map(row => ({
          team: row.team_abbr,
          athletes: row.athletes.map((val) => `${val.last_name}, ${val.first_name} ${val.initial}`).join('; '),
          letter: row.team_ltr,
          place: row.fin_place,
          points: row.ev_score,
          seed: row.actualseed_time === 0 ? 'NT' : this.getTime(row.actualseed_time),
          finish: this.finishTime({time: row.fin_time, stat: row.fin_stat})
        }));
      })
    }
  }
</script>

<style>

</style>
